module.exports = __webpack_public_path__ + "static/media/EE2.7f98116d.PNG";